import xhrService from "../xhrService";
import { apiError } from '../apiError';

export const inspectionTypeApi = {
  index: () =>
    xhrService
      .get(`/api/inspection-types`)
      .then(res => res.data)
      .catch((err) => {
        throw apiError(err);
      }),
  
  getByTemplateId: (templateId: number) =>
    xhrService
      .get(`/api/inspection-types/template/${templateId}`)
      .then(res => res.data)
      .catch((err) => {
        throw apiError(err);
      }),
};

export default inspectionTypeApi;
